import "./index.scss";;
import "../../kadence/assets/js/navigation.min.js";
import $ from "jquery";


function emptyMainNavLinks() {
    $('.menu-item a').each(function () {
        var el = $(this);
        if (el.attr('href') === '' || el.attr('href') === '#' ) {
            el.on('click', function (e) {
                e.preventDefault();
            });
        }
    });
}

$(document).ready(function() {
  
    emptyMainNavLinks();

});
